export default __webpack_public_path__ + "static/media/benefits-video-poster.c7ff825b.jpg";